import PropTypes from 'prop-types'
import React, { useState } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import { connect } from 'react-redux'
import CommentEdit from '../CommentEdit/index'
import Button, { TYPES } from '../Button/index'
import { getBoundActions } from '../../actions/index'
import { TYPE_COMMENT_REPORT } from '../../services/dialog/index'
import ReplyIcon from '../Icon/icons/Reply/index'
import FlagIcon from '../Icon/icons/Flag/index'
import PencilIcon from '../Icon/icons/Pencil/index'

function getRepliesCount (comment) {
  return (comment.commentsChildren || []).length
}

function getChildrenLimitText (props) {
  const { comment, commentThreadActionsStaticText } = props
  const count = getRepliesCount(comment)

  return `${commentThreadActionsStaticText.getIn([
    'data',
    'viewAllReplies',
  ])} (${count})`
}

function CommentThreadActions (props) {
  const {
    auth,
    comment,
    createComment,
    updateComment,
    reportComment,
    onEditClick,
    editMode = false,
    onClickChildrenLimit,
    commentThreadActionsStaticText,
    showReplyButton = true,
    showReportButton = true,
    showLimitButton = true,
    renderModal,
    dismissModal,
    addToasty,
  } = props

  const [isFlagged, setIsFlagged] = useState(false)
  const [replyVisible, setReplyVisible] = useState(false)

  const replyButtonClass = ['comment-thread-actions__reply-button'].concat(
    replyVisible ? 'comment-thread-actions__reply-button--active' : '',
  ).join(' ')

  const reportButtonClass = [
    'comment-thread-actions__report-button',
    isFlagged ? 'comment-thread-actions__report-button--flagged' : null,
  ].filter((cls) => !!cls).join(' ')

  const editButtonClass = ['comment-thread-actions__edit-button'].concat(
    editMode ? 'comment-thread-actions__edit-button--active' : '',
  ).join(' ')

  const handleReportClick = () => {
    if (isFlagged) {
      return
    }
    renderModal(TYPE_COMMENT_REPORT, {
      onSubmit: async () => {
        const success = await reportComment(comment.id)
        if (success) {
          setIsFlagged(true)
          addToasty(commentThreadActionsStaticText.getIn(['data', 'sendReportSuccess']))
        } else {
          addToasty(commentThreadActionsStaticText.getIn(['data', 'sendReportError']))
        }
        dismissModal()
      },
      staticText: commentThreadActionsStaticText,
    })
  }

  return (
    <div className="comment-thread-actions">
      {auth.get('jwt') ? (
        <div className="comment-thread-actions__buttons">
          {showReplyButton && <Button
              type={TYPES.ICON}
              iconSvg={<ReplyIcon size={18} />}
              className={replyButtonClass}
              onClick={() => {
                setReplyVisible(!replyVisible)
                onEditClick(null)
              }}
            >
              {commentThreadActionsStaticText.getIn(['data', 'reply'])}
            </Button>
          }
          {showReportButton && <Button
              type={TYPES.ICON}
              iconSvg={<FlagIcon size={18} />}
              className={reportButtonClass}
              onClick={handleReportClick}
            >
              {commentThreadActionsStaticText.getIn(['data', 'report'])}
            </Button>
          }
          {auth.get('jwt') && auth.get('uid') === comment.uid && <Button
              type={TYPES.ICON}
              iconSvg={<PencilIcon size={18} />}
              className={editButtonClass}
              onClick={() => {
                onEditClick(editMode ? null : comment.id)
                setReplyVisible(false)
              }}
            >
              {commentThreadActionsStaticText.getIn(['data', 'edit'])}
            </Button>
          }
        </div>
      ) : null}
      {replyVisible && !!createComment ? (
        <CommentEdit
          className={['comment-thread-actions__reply-textarea']}
          auth={auth}
          parent={comment}
          showAvatar={false}
          createComment={createComment}
          updateComment={updateComment}
          onSubmitComplete={() => setReplyVisible(false)}
        />
      ) : null}
      {showLimitButton && onClickChildrenLimit ? (
        <Button
          className="comment-thread-actions__children-limit"
          onClick={onClickChildrenLimit}
        >
          {getChildrenLimitText(props)}
        </Button>
      ) : null}
    </div>
  )
}

CommentThreadActions.propTypes = {
  commentThreadActionsStaticText: ImmutablePropTypes.map.isRequired,
  comment: PropTypes.object.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  onEditClick: PropTypes.func.isRequired,
  editMode: PropTypes.bool,
  createComment: PropTypes.func,
  updateComment: PropTypes.func,
  reportComment: PropTypes.func,
  onClickChildrenLimit: PropTypes.func,
  showReplyButton: PropTypes.bool,
  showReportButton: PropTypes.bool,
  showLimitButton: PropTypes.bool,
}

export default connect((state) => ({
  commentThreadActionsStaticText: state.staticText.getIn(
    ['data', 'commentThreadActions'],
    Map(),
  ),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    addToasty: actions.toasty.addToasty,
    renderModal: actions.dialog.renderModal,
    dismissModal: actions.dialog.dismissModal,
  }
})(CommentThreadActions)
